import { LinkField } from "../types/types";

export function getQueryLink(field?: LinkField) {
    if (field?.value?.querystring && !field.value.isQueryAppended) {
        field.value.href = `${field?.value.href ?? ''}${field?.value.querystring ?? ''}`;
        field.value.isQueryAppended = true;
    }
}